import { t } from '@lingui/core/macro';
import { z } from 'zod';

import { isBusinessEmail } from '@/helper/validator';

export type BusinessEmailErrorMessages = {
  email?: string;
  business?: string;
};

export const businessEmail = (errors?: BusinessEmailErrorMessages) => {
  return z
    .email({ message: errors?.email ?? t`Please use a valid email address`, abort: true })
    .refine(isBusinessEmail, errors?.business ?? t`Please use a work email, not a personal one`);
};
